<template>
  <div class="c-pc-title title-top" :class="{'no-top':noTop}">
    <div class="back-title ">
      {{ info.enName ? info.enName : 'INTRODUCTION' }}
    </div>
    <div class="title-name">
      {{ info.name ? info.name : "会议介绍" }}
    </div>

  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    info: {},
    noTop: {
      type:Boolean,
      default:false
    }
  }
};
</script>

<style scoped>

</style>
